import fetchAPI from '../fetchAPI';

/** A tier + purpose that runs a model — the blast radius of its price. */
export interface AiModelUsage {
  type: string;
  title?: string | null;
  purpose: string;
}

/** Claude effort levels — the only values the API accepts. */
export const AI_MODEL_EFFORTS = ['low', 'medium', 'high', 'xhigh', 'max'] as const;
export type AiModelEffort = (typeof AI_MODEL_EFFORTS)[number];

/** One row of the AI model registry (server: AiModels, migration 137). */
export interface AiModel {
  id: string;
  model: string;
  groupName?: string | null;
  sortOrder?: number | null;
  // USD per 1K tokens — the price every AI turn on this model is billed at.
  inputPrice: number;
  outputPrice: number;
  isActive: boolean;
  // Claude `output_config.effort` zazu sends for this model (migration 147). Null = zazu's default.
  effort?: AiModelEffort | null;
  updatedBy?: string | null;
  updatedAt?: string;
  usedBy: AiModelUsage[];
}

export interface AiModelPayload {
  model?: string;
  groupName?: string | null;
  sortOrder?: number | null;
  inputPrice?: number;
  outputPrice?: number;
  isActive?: boolean;
  effort?: AiModelEffort | null;
}

// Server responds with `{ code, data }` as the body, so the parsed body is
// nested under fetchAPI's own `.data` (same envelope as the Lookups calls).
export const callGetAiModels = async (): Promise<iResponse<{ code: number; data: AiModel[] }>> =>
  fetchAPI({ method: `GET`, route: `ai-models` });

export default callGetAiModels;
